export const LOGIN_ACTION = "LOGIN_ACTION";
export const LOGIN_ACTION_SUCCESS = "LOGIN_ACTION_SUCCESS";
export const LOGIN_ACTION_CANCELLED = "LOGIN_ACTION_CANCELLED";
export const LOGIN_ACTION_FAILED = "LOGIN_ACTION_FAILED";
export const GET_ORGANIZATION_SUCCESS = "GET_ORGANIZATION_SUCCESS";
export const GET_USERDETAILS_SUCCESS = "GET_USERDETAILS_SUCCESS";
export const USER_CREDENTIALS = "USER_CREDENTIALS";
